import type { SeriesRecording, SingleRecording } from '../../../data/recording/types';
import { KalturaRecordingLean, KalturaSeriesRecordingLean } from '../../composed';

export function processSingleRecording(recording: KalturaRecordingLean): SingleRecording {
  return {
    assetId: recording.assetId,
    createDate: recording.createDate,
    id: recording.id,
    status: recording.status,
    type: recording.type,
    viewableUntilDate: recording.viewableUntilDate,
  };
}

export function processSeriesRecording(recording: KalturaSeriesRecordingLean): SeriesRecording {
  return {
    createDate: recording.createDate,
    epgId: recording.epgId,
    id: recording.id,
    seriesId: recording.seriesId,
    type: recording.type,
  };
}
